import configuration from '../../constants/Configuration';
import shapeTypes from '../../constants/ShapeConstants';
import sessionActions from '../../actions/SessionActions';
import storeManager from '../../store/StoreManager';
import exporterUtils from '../../components/utils/ExporterUtils';
import videoUtils from '../../components/utils/VideoUtils';
import playController from '../../components/utils/PlayController';

const slidesPreloaderNew = {
    isPreloaded: false,
    firstPreloadedSlides: configuration.FIRST_PRELOADED_SLIDES,
    slidesImages: [],
    audios: [],
    slidesVideos: [],
    currentSlideIndex: 0,
    slidesLength: 0,
    isEditor: false,
    videoElements: [],

    videoFromSlideLoaded: false,
    currentSlideAssetsLength: 0,
    currentSlideAssetsCounter: 0,
    currentSlideAudiosLength: 0,
    currentSlideAudiosCounter: 0,
    audioDurationMap: [],

    preloadAssets(isEditor = false) {
        this.isEditor = isEditor;

        if (this.isPreloaded)
            return;

        exporterUtils.init();
        videoUtils.updateVideoPreloader(true);

        this.createAssetsList();
        this.prepareAssets();
        this.startPreloading();

        this.isPreloaded = true;
    },
    createAssetsList() {
        this.firstPreloadedSlides = configuration.FIRST_PRELOADED_SLIDES;
        this.slidesImages = [];
        this.audios = [];
        this.slidesVideos = [];
        this.currentSlideIndex = 0;
        this.slidesLength = 0;
        this.videoElements = [];
        this.videoFromSlideLoaded = false;
        this.currentSlideAssetsLength = 0;
        this.currentSlideAssetsCounter = 0;
        this.currentSlideAudiosLength = 0;
        this.currentSlideAudiosCounter = 0;
        this.audioDurationMap = [];

        const state = storeManager.getState();
        const slides = state.production.slides;
        var i;
        var j;
        var shapes;
        var shape;
        var assets = [];
        var slidesAssets;

        this.slidesLength = slides.length;

        for (i=0; i<slides.length; i++) {
            shapes = slides[i].content;
            slidesAssets = [];

            // add all images from each slide
            for (j=0; j<shapes.length; j++) {
                shape = shapes[j];

                if (shape.type == shapeTypes.BACKGROUND && shape.isVideo)
                    continue;

                //TODO -- should be included the assets from inside of a group
                if (shape.type == shapeTypes.BACKGROUND || shape.type == shapeTypes.CHARACTER || shape.type == shapeTypes.IMAGE) {
                    if (shape.xlinkHref && shape.xlinkHref.length > 0 && assets.indexOf(shape.xlinkHref) < 0) {
                        assets.push(shape.xlinkHref);
                        slidesAssets.push(shape.xlinkHref);
                    }
                }
            }

            this.slidesImages.push(slidesAssets);

            // videos
            this.slidesVideos.push(videoUtils.getSlideVideoHref(i));
        }

        // prepare audios
        if (!playController.isAudioEditorAvailable())
            return;

        const timelines = state.audioEditor.timelines;
        var audios = [];
        var audioAssets = [];
        var audioHrefs = [];

        for (i=0; i<timelines.length; i++) {
            audios = timelines[i].audios;

            for (j=0; j<audios.length; j++) {
                if (audioHrefs.indexOf(audios[j].href) < 0) {
                    audioAssets.push(audios[j]);
                    audioHrefs.push(audios[j].href);
                }
            }
        }

        var currentTime = 0;
        var newTime = 0;
        audios = [];

        for (i=0; i<slides.length; i++) {
            newTime = currentTime + slides[i].time;

            var slideAudios = [];
            for (j=0; j<audioAssets.length; j++) {
                if (audioAssets[j].left >= currentTime && audioAssets[j].left < newTime)
                    slideAudios.push(audioAssets[j].href);
            }

            currentTime = newTime;
            this.audios.push(slideAudios);
        }
    },
    prepareAssets() {
        const wrapper = document.createElement('div');
        wrapper.id = 'preloaderWrapper';
        wrapper.style.display = 'none';
        document.body.appendChild(wrapper);

        this.videoElements = [];

        var videoWrapper = document.getElementById('multipleVideos');

        if (videoWrapper)
            videoWrapper.innerHTML = '';

        var i;
        var oldVideo = document.getElementById('videoBackground');
        const currentIndex = storeManager.getState().currentSlide.currentSlideIndex;
        var videoHolder = document.createElement('div');

        videoWrapper.appendChild(videoHolder);

        if (oldVideo)
            oldVideo.style.display = 'none';

        for (i=0; i<this.slidesVideos.length; i++) {
            var videoHref = this.slidesVideos[i];
            var videoElement;

            if (videoHref != '') {
                videoElement = document.createElement('VIDEO');
                videoElement.id = 'video_' + i;
                videoElement.style.position = 'absolute';
                videoElement.style.top = '0px';
                videoElement.style.left = '0px';
                videoElement.style.width = '800px';
                videoElement.style.height = '450px';
                videoElement.className = 'audioItem';
                videoElement.preload = 'auto';
                videoElement.playsinline = true;
                videoElement.ondurationchange = this.onVideoItemLoaded.bind(this);
                videoElement.currentTime = videoUtils.getStartPoint(i);

                if (i != currentIndex)
                    videoElement.style.display = 'none';

                videoHolder.appendChild(videoElement);
            }

            this.videoElements.push(videoElement);
        }
    },
    startPreloading() {
        this.loadAssetsFromSlide(this.currentSlideIndex);
    },
    loadAssetsFromSlide() {
        var index = this.currentSlideIndex;

        if (index >= this.slidesLength) { // finished loading all the slides
            this.endPreloading();
            return;
        }

        this.videoFromSlideLoaded = false;

        // video from slide
        var videoHref = this.slidesVideos[index];

        if (videoHref != '')
            this.loadVideo(videoHref, index);
        else
            this.videoFromSlideLoaded = true;

        // all the images from the current slide
        var assetsFromSlide = this.slidesImages[index];
        var i;
        var url;

        this.currentSlideAssetsLength = assetsFromSlide.length;
        this.currentSlideAssetsCounter = 0;

        for (i=0; i<assetsFromSlide.length; i++) {
            url = assetsFromSlide[i];
            this.loadImage(url);
        }

        // all the audios from the current slide
        var audiosFromSlide = this.audios[index];

        this.currentSlideAudiosLength = audiosFromSlide.length;
        this.currentSlideAudiosCounter = 0;

        for (i=0; i<audiosFromSlide.length; i++) {
            url = audiosFromSlide[i];
            this.loadAudio(url);
        }

        this.checkIfCurrentSlideIsLoaded();
    },

    //videos
    loadVideo(url, index) {
        var video = this.videoElements[index];
        video.src = videoUtils.checkCacheBreaker(videoUtils.getCorrectUrl(url));
    },
    onVideoItemLoaded() {
        console.log('Preloaded video');

        this.videoFromSlideLoaded = true;
        this.checkIfCurrentSlideIsLoaded();
    },

    // images
    loadImage(url) {
        var imageObj = new Image();
        var self = this;

        imageObj.onload = function() {
            self.currentSlideAssetsCounter = self.currentSlideAssetsCounter + 1;
            self.checkIfCurrentSlideIsLoaded();
        };

        imageObj.onerror = function() {
            self.currentSlideAssetsCounter = self.currentSlideAssetsCounter + 1;
            self.checkIfCurrentSlideIsLoaded();
        };

        imageObj.src = videoUtils.checkCacheBreaker(url);

        var preloaderWrapper = document.getElementById('preloaderWrapper');
        preloaderWrapper.appendChild(imageObj);
    },

    // audios
    loadAudio(url) {
        var audio = new Audio();
        var self = this;

        audio.ondurationchange = function() {
            self.currentSlideAudiosCounter = self.currentSlideAudiosCounter + 1;
            self.checkIfCurrentSlideIsLoaded();

            self.audioDurationMap[url] = audio.duration;
        };

        audio.onerror = function() {
            self.currentSlideAudiosCounter = self.currentSlideAudiosCounter + 1;
            self.checkIfCurrentSlideIsLoaded();
        };

        audio.src = videoUtils.checkCacheBreaker(url);
        audio.load();

        var preloaderWrapper = document.getElementById('preloaderWrapper');
        preloaderWrapper.appendChild(audio);
    },

    checkIfCurrentSlideIsLoaded() {
        if (this.videoFromSlideLoaded && this.currentSlideAssetsCounter >= this.currentSlideAssetsLength && this.currentSlideAudiosCounter >= this.currentSlideAudiosLength) { // all the content from current slide is loaded
            this.currentSlideIndex = this.currentSlideIndex + 1;

            this.checkPreloader();
            this.loadAssetsFromSlide();
        }
    },
    checkPreloader() {
        if ((this.slidesLength >= this.firstPreloadedSlides && this.currentSlideIndex >= this.firstPreloadedSlides) || (this.slidesLength < this.firstPreloadedSlides  && this.currentSlideIndex >= this.slidesLength)) {
            const store = storeManager.getStore();

            if (!this.isEditor)
                store.dispatch(sessionActions.setCaptionsLoaded());
        }
    },
    endPreloading() {
        var elem = document.getElementById('preloaderWrapper');

        if (elem && elem.parentElement)
            elem.parentElement.removeChild(elem);

        videoUtils.updateVideoPreloader(false);

        videoUtils.setInPoints();
    },
    exitPreview() {
        var multipleVideosWrapper = document.getElementById('multipleVideos');

        if (multipleVideosWrapper)
            multipleVideosWrapper.innerHTML = '';

        this.isPreloaded = false;

        var oldVideo = document.getElementById('videoBackground');

        if (oldVideo)
            oldVideo.style.display = 'block';
    }

};

export default slidesPreloaderNew;



/** WEBPACK FOOTER **
 ** ./src/components/utils/SlidesPreloaderNew.js
 **/